module.exports = __webpack_public_path__ + "static/media/dribbble.379d1d1c.svg";